import { FC, useState } from 'react';
import { Button, Input, Modal } from 'rsuite';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCancel: (reason: string) => void;
}

export const CancelRoomModal: FC<Props> = ({ isOpen, onClose, onCancel }) => {
  const [reason, setReason] = useState('');

  return (
    <Modal show={isOpen} onHide={onClose} size="xs">
      <Modal.Header>
        <Modal.Title>鑑定をキャンセルしますか？</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-4">*誤って申請した場合は運営までお問い合わせください</p>
        <label>キャンセル理由</label>
        <Input value={reason} onChange={(value) => setReason(value)} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="subtle">
          キャンセル
        </Button>
        <Button
          disabled={!reason}
          onClick={() => onCancel(reason)}
          color={`${reason ? 'blue' : 'cyan'}`}
          appearance={`${reason ? 'primary' : 'subtle'}`}
        >
          申請する
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
